export default {
    name: "SeriesGalleryWidget",
    type: "DataWidget",
    description: "Browse your video series.",
    roles: ["appUser"],
    widget: {
        title: "My Series",
        size: "large",
        dataProvider: {
            main: {
                rpc: "SeriesRpc.getData",
                params: { pageSize: 4 },
                transform: (res) => res.data
            }
        },
        fields: [
            { name: "name", isTitle: true },
            { name: "genre", isSubtitle: true },
            { name: "videoStyle", isMeta: true, render: (val) => val ? val.replace(/_/g, ' ') : '' }
        ],
        noDataMessage: "No series created yet."
    }
};